var Glyphicon = require("components/utility/icons/Glyphicon");

var CopyToClipboard = require("copy-to-clipboard");

require("utility/copy_text_input.scss");

class CopyTextInput extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.input = React.createRef();
	}

	onFocus() {
		this.input.current.select();
	}

	onCopyClick() {
		CopyToClipboard(this.props.text);
	}

	render() {
		return (
			<div className="copyTextInput">
				<input className="form-control" value={ this.props.text }
					onFocus={ this.onFocus } readOnly ref={ this.input } />

				<button className="btn btn-default" onClick={ this.onCopyClick }>
					<Glyphicon icon="copy" />
				</button>
			</div>
		);
 	}
};

CopyTextInput.propTypes = StrictPropTypes({
	text: PropTypes.string.isRequired,
});

module.exports = CopyTextInput;



// WEBPACK FOOTER //
// ./modules/components/utility/CopyTextInput.js